import React from "react";
import { Container, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
export default function CGU() {
  const navigate = useNavigate();
  return (
    <Container className="cgu-page">
      <h2 className="cgu-title">Conditions Générales d’Utilisation</h2>
      <Button
        variant="outline-secondary"
        className="legal-back-btn"
        onClick={() => navigate("/")}
        type="button"
      >
        Retour
      </Button>
      <section>
        <h5>1. Objet</h5>
        <p>
          Les présentes Conditions Générales d’Utilisation (CGU) ont pour objet
          de définir les modalités d’utilisation du service de réservation VTC
          proposé sur ce site.
        </p>
      </section>

      <section>
        <h5>2. Réservation</h5>
        <p>
          Toute réservation effectuée via le site implique l’acceptation pleine
          et entière des présentes CGU. Les informations fournies doivent être
          exactes.
        </p>
      </section>

      <section>
        <h5>3. Tarification</h5>
        <p>
          Les tarifs affichés sont donnés à titre indicatif. Le prix final peut
          varier selon les conditions réelles du trajet (trafic, détours,
          attente).
        </p>
      </section>

      <section>
        <h5>4. Annulation</h5>
        <p>
          Toute annulation doit être signalée au plus tôt. Des frais peuvent
          être appliqués selon le délai.
        </p>
      </section>

      <section>
        <h5>5. Responsabilité</h5>
        <p>
          Le prestataire ne saurait être tenu responsable des retards dus à des
          circonstances indépendantes de sa volonté.
        </p>
      </section>

      <section>
        <h5>6. Données personnelles</h5>
        <p>
          Les données collectées sont utilisées uniquement dans le cadre de la
          réservation et ne sont jamais revendues.
        </p>
      </section>

      <section>
        <h5>7. Droit applicable</h5>
        <p>Les présentes CGU sont soumises au droit français.</p>
      </section>
    </Container>
  );
}
